







import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  name: 'form-error',
  components: {},
})
export default class FormError extends mixins(BaseMixin) {
  @Prop({ type: Array, required: true })
  errors!: Record<string, string[] | undefined>;
}
